<ng-container *ngIf="modelIds$ && asOfDate; else loading">
	<section class="padding-bottom-20 dz-hidden dz-block-lg" *ngIf="asOfDate">
		<span dcrHTMLKey="FAMILY_AS_OF">As of</span> {{ asOfDate }}
		<span *ngIf="modelIdsList.length > config?.options?.componentBreakpoint" class="dz-pull-right text-14" dcrHTMLKey="SCROLL_RIGHT_INDICATOR"></span>
	</section>

	<ng-template
		*ngIf="!noPreviousHoldings; else noInfoTemplate"
		[componentId]="{ componentId: 'me.family.changesToHoldings', ids: modelIds$ }"
		let-detailsData
		[error]="errorTemplate"
	>
		<ng-template
			*ngIf="!noPreviousHoldings; else noInfoTemplate"
			[componentId]="{ componentId: 'me.family.changesToHoldings', ids: familyIds$ }"
			let-headerData
			[error]="errorTemplate"
		>
			<section class="bordered-container family-changes-holding-table-container no-padding">
				<hl-holdings-table-header
					[data]="headerData"
					[dataTabId]="'changesToHoldings.header'"
					[holdingsData]="detailsData"
					[holdingsDataTabId]="'changesToHoldings'"
					[modelIds]="modelIds$ | async"
					[multiRowLeftHeader]="multiRowLeftHeader"
					[headerColumns]="changesToHoldingsHeaderColumns"
					[isPortfolioClickable]="enablePortfolioLinks"
					(onPortfolioClicked)="redirectTo360($event)"
					[familyAsOf]="asOfDate"
					(selectedPortfolio)="updateTableDataForSelectedPortfolio($event)"
				></hl-holdings-table-header>

				<hl-scrollable-holdings-table [data]="detailsData" [config]="config"></hl-scrollable-holdings-table>
			</section>
		</ng-template>

		<ac-disclosure [isExpandable]="false"><span dcrHTMLKey="CHANGES_HOLDINGS_DISCLOSURE">CHANGES_HOLDINGS_DISCLOSURE</span></ac-disclosure>
		<mb-family-footer *ngIf="showFundPerfTableLink"></mb-family-footer>
	</ng-template>
</ng-container>
<ng-template #errorTemplate>
	<div class="margin-object-3 margin-object-0-sm" dcrHTMLKey="CHANGES_HOLDINGS_ERROR">The holdings data is currently not available for this model</div>
</ng-template>
<ng-template #noInfoTemplate>
	<div class="margin-object-3 margin-object-0-sm" dcrHTMLKey="NO_CHANGES_HOLDINGS_INFO">The information is currently not available for this model</div>
</ng-template>
<ng-template #loading>
	<mb-family-changes-to-holdings-skeleton></mb-family-changes-to-holdings-skeleton>
</ng-template>
